/* [PATCH nadzorna-stranka v1] 15.10.2026 — vloga `stranka` nima nadzorne plosce.
   Tudi neposredna povezava /nadzorna jo preusmeri na '/' (izbira aplikacije).
   Ostale vloge: DashboardPage kot doslej. */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { DashboardPage } from '../pages/DashboardPage';

export function NadzornaRuta() {
  const vloga = useAuthStore((s: any) => s.role);
  if (vloga === 'stranka') return <Navigate to="/" replace />;
  return <DashboardPage />;
}

export default NadzornaRuta;
